export default "__VITE_ASSET__Cdn5o7FY__"